// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2RKu2","Success":"Button_Success__2kP2f","Danger":"Button_Danger__3eMGJ"};